
<template>
  <div>
    <base-card :option="cardOption">
      <div slot="cardBody">
        <search-form @setSearchCondition="setSearchCondition" @clearSearch="clearSearch"></search-form>
        <!--      操作按钮-->
        <div class="table-operator">
          <a-button style="margin-right: 10px" type="primary" icon="plus" @click="handleAdd">新增</a-button><a-popconfirm
            title="确定要批量删除吗?"
            @confirm="batchDel" >
            <a-button icon="delete" >批量删除</a-button>
          </a-popconfirm>
        </div>
        <!--表格-->
        <div class="table">
          <a-table
            :columns="table.columns"
            :rowKey="record => record.id"
            :dataSource="table.data"
            :pagination="pagination"
            :loading="table.loading"
            @change="handleTableChange"
            :rowSelection="rowSelection"
          >
            <template slot="num" slot-scope="text,record,index">
              {{index+1}}
            </template>
            <template slot="actions" slot-scope="text, record">
              <a href="javascript:;" @click="() => handleEdit(record)">编辑</a>
              <a-divider type="vertical" />
              <a href="javascript:;" @click="() => handleOpenSale(record)">销售记录</a>
              <a-divider type="vertical" />
              <a href="javascript:;" @click="() => handleView(record)">详情</a>
              <a-divider type="vertical" />
              <a-popconfirm v-if="table.data.length" title="确定要删除吗?" @confirm="() => onDelete(record)">
                <a href="javascript:;" style="color:red;">删除</a>
              </a-popconfirm>
            </template>
          </a-table>
        </div>
      </div>
    </base-card>
    <!--各种弹出组件-->
    <edit-modal :associatedSelect="associatedSelect" ref="editModal" @refreshTable="initTableData"></edit-modal>
    <sale-modal ref="saleModal"></sale-modal>
    <view-modal ref="viewModal"></view-modal>
  </div>
</template>

<script>
import { getProductList, deleteProduct, getProductInfo } from '@/api/product'
import editModal from './modules/editModal'
import searchForm from './modules/searchForm'
import baseCard from '@/CrComponents/Card/Card'
import viewModal from './modules/viewModal'
import saleModal from './modules/saleModal'
export default {
  name: 'ProductList',
  mounted () {
    this.searchModel = { ...this.paging }
    this.initTableData()
    this.initData()
  },
  computed: {

  },
  components: {
    editModal,
    searchForm,
    baseCard,
    viewModal,
    saleModal
  },
  data () {
    return {
      // card相关属性设置
      cardOption: {},
      // 搜索form中的参数
      searchFormModel: {},
      // 所有搜索条件 包括分页，搜素框，表格上筛选条件
      searchModel: {},
      // 表格中的查询条件
      searchTableModel: {},
      // 高级搜索 展开/关闭
      searchInput: null,
      searchText: '',
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          this.selectedRows = selectedRows
        }
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      paging:{paging:true},
      table: {
        data: [],
        config: {},
        columns: [
          {
            title: '序号',
            scopedSlots:
                {
                    customRender: 'num'
                }
          }, 
          {
          title: '产品编号',
          dataIndex: 'productNumber'
          },
          {
          title: '产品线',
          dataIndex: 'productLine'
          },
          {
          title: '产品名称',
          dataIndex: 'productName'
          }, 
          {
          title: '产品功能',
          dataIndex: 'modulesName',
          }, 
          {
          title: '操作',
          scopedSlots:{customRender: 'actions'},
          width:250
          },
        ],
        searchCondition: {},
        loading: false,
        filteredInfo: null,
        sortedInfo: null
      },
      associatedSelect:[]
    }
  },
  methods: {
    // 初始化其他数据 下拉列表
    initData(){
      //初始化生产线列表
      this.$store.dispatch('handleProductLineList')
      this.$store.dispatch('handleProductTypeList')
    },
    // 获取选中的table
    rowSelectChange (value) {
      this.selectedRows = value
    },
    // 导入
    handleImport () {
      this.$refs.importModal.setModel(this.model)
      this.$refs.importModal.open(true)
    },
    // 搜索
    setSearchCondition (searchFormModel) {
      this.searchFormModel = searchFormModel
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = { ...this.paging, ...this.searchTableModel, ...searchFormModel }
      this.initTableData()
    },
    // 重置
    clearSearch (searchFormModel) {
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = { ...this.paging , ...this.searchTableModel }
      this.initTableData()
    },
    // 表格中的搜索
    handleSearch (selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    // 表格中的重置
    handleReset (clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    // 初始化表格数据
    async initTableData () {
      const res = await getProductList(this.searchModel).catch(err => {
        console.log('初始化失败', err)
      })
      if (res && res.status === 0) {
        this.table.loading = false
        this.table.data = res.data.list
        //关联产品列表
        this.associatedSelect = res.data.list.map((val)=>{
          return {
            id:val.id,
            productName:val.productName
          }
        })
        this.pagination.total = res.data.total
        console.log(res.data.list);
      } else {
        this.$message.warning('获取数据失败！')
      }
    },
    // 切换页码等操作
    handleTableChange (pagination, filters, sorter) {
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.pagination.current = pagination.current
      this.searchModel = {
        ...this.searchModel,
        ...this.pagination
      }
      this.initTableData()
    },
    async deleteFn (ids) {
      const res = await deleteProduct({ids:ids}).catch(err => {
        console.log('初始化失败', err)
      })
      if (res && res.status === 0) {
        this.$message.success(res.info.message)
        this.initTableData()
      } else {
        this.$message.warning(res.info.message)
      }
    },
    // 删除操作
    onDelete (model) {
      this.deleteFn(model.id)
    },
    // 查看详情
    async handleView (model) {
      console.log(model.id);
      const res = await getProductInfo({id:model.id}).catch(err => {
        console.log('初始化失败',err);
      })
      if (res && res.status === 0){
        this.$refs.viewModal.setTitle('查看产品')
        this.$refs.viewModal.setType(this.$sysInfo.MODAL_VIEW)
        this.$refs.viewModal.setModel(res.data) // 先设置类型，再打开
        console.log('res_data:',res.data);
        this.$refs.viewModal.open(true)
      } else {
        this.$message.warning('获取数据失败！')
      }
    },
    // 销售记录
    handleOpenSale(model){
      this.$refs.saleModal.setModel(model)
      this.$refs.saleModal.open(true)
    },
    // 编辑
    async handleEdit (model) {
      console.log(model.id);
      const res = await getProductInfo({id:model.id}).catch(err => {
        console.log('初始化失败',err);
      })
      if (res && res.status === 0){
        this.$refs.editModal.setTitle('编辑产品')
        this.$refs.editModal.setType(this.$sysInfo.MODAL_MODIFY)
        this.$refs.editModal.setModel(res.data)// 先设置类型，再打开
        this.$refs.editModal.open(true)
      } else {
        this.$message.warning('获取数据失败！')
      }
      
    },
    // 新增
    handleAdd () {
      this.$refs.editModal.setTitle('新增产品信息')
      this.$refs.editModal.setType(this.$sysInfo.MODAL_ADD)// 先设置类型，再打开
      this.$refs.editModal.open(true)
    },
    // 批量删除
    async batchDel () {
      const searchModel = this.selectedRows
      if (!searchModel || searchModel.length === 0) {
        this.$message.warning('请至少选择一行数据进行删除！')
        return
      }
      let params = ''
      searchModel.map(item => {
        params += item.id + ','
      })
      params = params.substring(0, params.length - 1)
      this.deleteFn(params)
    }
  }
}
</script>

<style scoped  lang="less">
.listContent {
  .table {
    margin-top: 10px;
  }
}
</style>
